import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=367fda32&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Page.vue?vue&type=style&index=1&id=367fda32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367fda32",
  null
  
)

export default component.exports